<blaze-dialog
  (closeDialog)="action('cancel')"
  [showFooter]="true"
  class="bulk-edit-dialog"
  closeButtonStyling="bat-secondary"
>
  <div title> Edit field(s) </div>
  <mat-icon icon svgIcon="icon_edit_24" />

  <div
    content
    class="modal-content w-[496px] flex flex-col text-center gap-8"
    [formGroup]="formGroup"
    data-cy="BulkEditDialog:Content"
  >
    <ng-container formArrayName="array">
      @for (bulkEditGroup of bulkEditArrayControls; track $index; let i = $index) {
        <div class="flex justify-between gap-8 items-center">
          <ng-container [formGroup]="bulkEditGroup">
            <blaze-select
              (valueChange)="changeEditorConfig(i, $event)"
              [allowNone]="false"
              [attr.data-cy]="'BulkEditDialog:Column:' + i"
              [options]="unusedColumnsToChange(bulkEditGroup.controls['name'].value)"
              [useAppTheme]="true"
              filterPlaceholder="Choose field"
              formControlName="name"
            />
            @if (bulkEditGroup.controls['name'].value) {
              <be-base-editor
                #editorTpl
                (focusLost)="setValueForControl(bulkEditGroup.controls['name'].value, i, $event)"
                [attr.data-cy]="'BulkEditDialog:Value:' + i"
                layoutMode="input-like"
              />
            }
            <button
              (click)="removeFormGroup(i)"
              [attr.data-cy]="'BulkEditDialog:Remove:' + i"
              blazeIconButton="bat"
              blazeIconButtonSize="lg"
            >
              <mat-icon svgIcon="icon_trash_16" />
            </button>
          </ng-container>
        </div>
      }
    </ng-container>
  </div>

  <div footer class="flex w-full justify-between items-center gap-8 flex-row">
    <button
      (click)="addFormGroup()"
      [disabled]="!unusedColumnsLength || formGroupArrayLength >= availableColumnsLength"
      class="btn-add bd-btn add-item-button"
      data-cy="BulkEditDialog:AddField"
    >
      <mat-icon svgIcon="icon_add_8" class="add-item-style" />
      ADD FIELD
    </button>
    <button
      (click)="action('continue')"
      [disabled]="isSaveDisabled"
      blazeButton="bat"
      blazeButtonSize="xl"
      data-cy="BulkEditDialog:Save"
    >
      Save Changes
    </button>
  </div>
</blaze-dialog>
